import { NetworkPosIcon } from './NetworkPosIcon';

/**
 * author: emeraldmor
 * id D9BB8F7B-1014-42A4-BBC3-3ED704847943
 * name network-pos
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/network-pos.svg
 * tags
 * - Banking 
 */
export const NetworkPointOfSaleIcon = NetworkPosIcon;
export default NetworkPointOfSaleIcon